import React from 'react'
import { Line as LineChart, Doughnut } from 'react-chartjs-2'
//import moment from 'moment'
import Multi from '../Multi'

import './style.css'

//var timeFormat = 'MM/DD/YYYY HH:MM'

export const Preloader = ({ opaque, transparent, label }) => (
    <Multi>
        <div
            style={{
                position: 'absolute',
                background: 'white',
                opacity: opaque ? 1 : transparent ? 0 : 0.95,
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 12365
            }}
        />
        <div
            style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                zIndex: 12367
            }}>
            <img
                alt="preloader"
                src="/img/preloader.svg"
                style={{
                    width: 39,
                    height: 39,
                    display: 'block'
                }}
            />
            <span style={{ color: '#898989', fontSize: 12 }}>{label || 'Loading'}</span>
        </div>
    </Multi>
)

export const EmptyGraph = ({ opaque, transparent }) => (
    <Multi>
        <div
            style={{
                position: 'absolute',
                background: 'white',
                opacity: opaque ? 1 : transparent ? 0 : 0.95,
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 12365
            }}
        />
        <div
            style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                zIndex: 12367
            }}>
            <img
                alt="preloader"
                src="/img/no-data-graph.svg"
                style={{
                    // width: 39,
                    // height: 39,
                    display: 'block'
                }}
            />
            <span style={{ color: '#898989', fontSize: 12 }} />
        </div>
    </Multi>
)

export const DoughnutChart = ({ data }) => {
    const sumWeb = data.data.web.reduce((sum, i) => i.hits + sum, 0)
    const sumIos = data.data.ios.reduce((sum, i) => i.hits + sum, 0)
    const sumAndroid = data.data.android.reduce((sum, i) => i.hits + sum, 0)
    const douData = {
        labels: ['Web', 'iOS', 'Android'],
        datasets: [
            {
                data: [sumWeb, sumIos, sumAndroid],
                backgroundColor: ['rgba(111, 124, 215,1)', 'rgba(0, 168, 229,1)', 'rgba(0, 238, 153,1)'],
                hoverBackgroundColor: ['rgba(111, 124, 215,1)', 'rgba(0, 168, 229,1)', 'rgba(0, 238, 153,1)']
            }
        ]
    }
    return <Doughnut data={douData} options={{}} />
}

const Chart = ({ data, title }) => {
    const loading = data.loading
    let chartOptions = {
        maintainAspectRatio: false,
        legend: {
            position: 'top',
            labels: { textAlign: 'end', usePointStyle: true }
        },
        scales: {
            yAxes: [
                {
                    stacked: true
                }
            ]
        }
    }

    const split = { ios: [], android: [], web: [] }
    for (let h of data.data) {
        const [creation, platform] = h.platform_creation.split('_')
        const cDate = new Date(parseInt(creation, 10))
        const t = `${cDate.getDate()}/${cDate.getMonth() + 1}`
        const y = h.hits
        split[platform].push({ t, y })
    }

    if (split.ios.length === 1) split.ios.unshift({ t: '', y: 0 })
    if (split.android.length === 1) split.android.unshift({ t: '', y: 0 })
    if (split.web.length === 1) split.web.unshift({ t: '', y: 0 })

    const chartData = {
        labels: split.web.map(w => w.t),
        datasets: [
            {
                lineTension: 0.3,
                label: 'iOS SDK',
                data: split.ios,
                backgroundColor: 'rgba(0, 238, 153, 0.3)',
                pointBackgroundColor: 'rgba(255, 255, 255, 1)',
                pointRadius: 4,
                borderColor: 'rgba(0, 238, 153,1)',
                borderWidth: 2
            },
            {
                lineTension: 0.3,
                label: 'Android SDK',
                data: split.android,
                backgroundColor: 'rgba(0, 168, 229, 0.5)',
                pointBackgroundColor: 'rgba(255, 255, 255, 1)',
                pointRadius: 4,
                borderColor: 'rgba(0, 168, 229, 1)',
                borderWidth: 2
            },

            {
                lineTension: 0.3,
                label: 'Web',
                data: split.web,
                backgroundColor: ['rgba(107, 120, 214, 0.5)'],
                pointBackgroundColor: 'rgba(255, 255, 255, 1)',
                pointRadius: 4,
                borderColor: ['rgba(111, 124, 215,1)'],
                borderWidth: 2
            }
        ]
    }
    return (
        <div className="white-box analytics-info" style={{ position: 'relative' }}>
            {loading && <Preloader />}
            {!loading && split.web.length === 0 && <EmptyGraph />}
            <h3 className="box-title" style={{ marginBottom: 30 }}>
                {title}
            </h3>
            <ul className="list-inline">
                <LineChart data={chartData} options={chartOptions} height={380} />
            </ul>
        </div>
    )
}

export default Chart
